// studentApi.ts
import api from "./api";

export const createStudent = (data: any) => {
  return api.post("/students", {
    name: data.name,
    email: data.email,
    mobile: data.mobile,
    gender: data.gender,
    dob: data.dob, // ✅ send as-is (YYYY-MM-DD)
  });
};

export const updateStudent = (id: number, data: any) => {
  return api.put(`/students/${id}`, {
    name: data.name,
    email: data.email,
    mobile: data.mobile,
    gender: data.gender,
    dob: data.dob,
  });
};

export const getStudents = (page: number = 0, size: number = 10, search?: string) => {
  return api.get("/students", {
    params: { page, size, ...(search ? { search } : {}) }
  });
};

export const getStudentById = (id: number) => {
  return api.get(`/students/${id}`);
};

export const deleteStudent = (id: number) => {
  return api.delete(`/students/${id}`);
};
